import React from 'react'

type SelectOption = {
  key?: string
  text: string
  value: any
}

type SelectProps = {
  value: any
  options: SelectOption[]
  placeholder?: string
  className?: string
  onChange: (value: any) => void
}

export default function Select(props: SelectProps) {
  const options = props.options ?? []
  const className = props.className ?? 'text-4xl text-gray-itx4 outline-none font-bold hover:bg-itx-primary-lightest rounded'
  return (
    <select value={props.value} className={`selector ${className}`} onChange={(event) => props.onChange(event.target.value)}>
      {props.placeholder && <option value={-1}>{props.placeholder}</option>}
      {options.map((o) => (
        <option key={o.key ?? o.text} value={o.value}>
          {o.text}
        </option>
      ))}
    </select>
  )
}
